import { Badge } from '@mantine/core'
import BadgeClasses from './styles.module.css'

export default Badge.extend({
    defaultProps: { size: 'md', radius: 'xl', variant: 'light', color: 'gray' },
    classNames: BadgeClasses,
})
